import React from 'react'
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title'

const FaqWrapper = ({ children, route }) => {
  return (
    <DocumentTitle title={ route.title }>
      { children }
    </DocumentTitle>
  )
}
FaqWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  route: PropTypes.object.isRequired,
}

export default FaqWrapper
